// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__3HglL","background":"style__background__iU5-K","footer":"style__footer__zTJ6c"};